// Organization home: queryOptions with the shared key (spec 10 § 9). The org id comes from the workspace layout
// (slug → id from /me); the organization list is /me's memberships, so the switcher needs no request of its own.
import { queryOptions } from '@tanstack/react-query'
import { api } from '../../shared/api/api'
import { keys } from '../../shared/query/keys'

export const orgHomeQuery = (orgId: string) =>
  queryOptions({
    queryKey: keys.orgHome(orgId),
    queryFn: async ({ signal }) => {
      const { data } = await api.GET('/orgs/{orgId}/home', { params: { path: { orgId } }, signal })
      return (
        data ?? {
          counts: {
            members: 0,
            teams: 0,
            openTasks: 0,
            myOpenTasks: 0,
            doing: 0,
            dueToday: 0,
            dueTodayDone: 0,
            doneThisWeek: 0,
            overdue: 0,
          },
          recent: [],
        }
      )
    },
    staleTime: 15_000,
  })
